/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".alert-icon[_ngcontent-%COMP%], .info-icon[_ngcontent-%COMP%], .question-icon[_ngcontent-%COMP%]{max-width:50px}.modal-header[_ngcontent-%COMP%]{font-size:1.3em}.modal-body[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center}.btn[_ngcontent-%COMP%]{min-width:70px}"];
export { styles as styles };
